export const dbDurees = [
    {
        id_duree : 1,
        nom:"1h",
        infos:"1 heure"
    },
    {
        id_duree : 2,
        nom:"2h",
        infos:"2 heures"
    },
    {
        id_duree : 3,
        nom:"4h",
        infos:"4 heures"
    },
    {
        id_duree : 4,
        nom:"sunset",
        infos:"Forfait sunset"
    },
    {
        id_duree : 5,
        nom:"24h",
        infos:"Forfait 24 heures"
    },
    {
        id_duree : 6,
        nom:"jour",
        infos:"Forfait Jour"
    }
];

export const grilleDuree=[
    //grille 1 = planches
    {
        grille_id:1,
        duree_id:1, //1 heure
        tarif:8
    },
    {
        grille_id:1,
        duree_id:2,//2 heures
        tarif:15
    },
    {
        grille_id:1,
        duree_id:3, // 4 heures
        tarif:25
    },
    {
        grille_id:1,
        duree_id:4, // sunset
        tarif:25 // idem 4h
    },
    {
        grille_id:1,
        duree_id:5, // 24H
        tarif:30 // idem jour
    },
    {
        grille_id:1,
        duree_id:6, // 1 jour
        tarif:30
    },
    //grille 2 = combi
    {
        grille_id:2,
        duree_id:1,//1 heure
        tarif:3
    },
    {
        grille_id:2,
        duree_id:2,//2 heures
        tarif:5
    },
    {
        grille_id:2,
        duree_id:3, // 4 heures
        tarif:8
    },
    {
        grille_id:2,
        duree_id:4, // sunset
        tarif:8 // idem 4h
    },
    {
        grille_id:2,
        duree_id:5, // 24H
        tarif:10 // idem jour
    },
    {
        grille_id:2,
        duree_id:6, // 1 jour
        tarif:10
    },
    //grille 3 = formules
    {
        grille_id:3,
        duree_id:1,//1 heure
        tarif:10
    },
    {
        grille_id:3,
        duree_id:2,//2 heures
        tarif:18
    },
    {
        grille_id:3,
        duree_id:3, // 4 heures
        tarif:30
    },
    {
        grille_id:3,
        duree_id:4, // sunset
        tarif:30 // idem // idem 4h
    },
    {
        grille_id:3,
        duree_id:5, // 24H
        tarif:35 // idem jour
    },
    {
        grille_id:3,
        duree_id:6, // 1 jour
        tarif:35
    }
];

/* export const dbArticles = [
    {
        id_article:1,
        type_id:1,
        categorie_id:1,
        taille_id:[1,2,3],
        nom:"planche",
        grille_id:1,
        description:"débutant",
        image_url:""

    },
    {
        id_article:2,
        type_id:2,
        categorie_id:2,
        taille_id:[3,4,5],
        nom:"combi",
        grille_id:2,
        description:"3/2 mm",
        image_url:""

    },
];

export const dbTailles = [
    {
        id_taille:1,
        type_id:1,
        taille:`6'6"`
    },
    {
        id_taille:2,
        type_id:1,
        taille:`6'9"`
    },
    {
        id_taille:3,
        type_id:1,
        taille:`7'6"`
    },
    {
        id_taille:4,
        type_id:2,
        taille:`XXS`
    },
    {
        id_taille:5,
        type_id:2,
        taille:`XXXL`
    },
    {
        id_taille:6,
        type_id:2,
        taille:`M`
    },
    
] */